module.exports = __webpack_public_path__ + "media/site_templates/www.paintersnearme.net.au/images/about_us-24e8a175ab87591b75ca7647f109785a.jpg";